import moment from "moment";
import { resolveImageUrl, format_date } from "../../Utils/helpers";

const AVATAR_FALLBACK = "images/userImage.png";

const STATUS_CHIPS = {
  pending: { label: "Waiting", className: "is-pending" },
  active: { label: "Live", className: "is-active" },
};

export default function List({ item, handleTabClick, chatTab, isMobileView }) {
  const participantId = (item?.receiverId || item?.user?._id)?.toString();
  const isActive = chatTab?.toString() === participantId;
  const profileSrc = resolveImageUrl(item?.user?.profileImage, AVATAR_FALLBACK);
  const displayName =
    [item?.user?.firstName, item?.user?.lastName].filter(Boolean).join(" ") ||
    item?.user?.firstName ||
    "User";

  const roleLabel =
    item?.user?.role === "driver"
      ? "Driver"
      : item?.user?.role === "user"
        ? "User"
        : item?.user?.role || "User";

  const chip = STATUS_CHIPS[item?.status];
  const isPending = item?.status === "pending";
  const agentName = item?.agent?.firstName || "";
  const timeLabel = isPending && item?.requestedAt
    ? moment(item.requestedAt).fromNow(true)
    : item?.lastMessageDate
      ? format_date(item.lastMessageDate, "hh:mm A")
      : "";

  return (
    <li className={`premium-chat-item ${isActive ? "active" : ""}`}>
      <button
        type="button"
        onClick={() => handleTabClick(participantId)}
        className="premium-chat-item-btn"
        aria-current={isActive ? "true" : undefined}
      >
        <div className="premium-chat-item-avatar-wrap">
          <img
            src={profileSrc}
            alt={displayName}
            className="premium-chat-item-avatar"
            onError={(e) => {
              e.currentTarget.src = AVATAR_FALLBACK;
            }}
          />
          {item.unreadCount > 0 && !isActive && (
            <span className="premium-chat-item-dot" />
          )}
        </div>

        <div className="premium-chat-item-body">
          <div className="premium-chat-item-top">
            <h2>{displayName}</h2>
            {timeLabel && <time>{timeLabel}</time>}
          </div>
          {(chip || item?.topic) && (
            <div className="premium-chat-item-meta">
              {chip && (
                <span className={`premium-chat-chip ${chip.className}`}>
                  {isPending && item?.queuePosition ? `#${item.queuePosition} ${chip.label}` : chip.label}
                  {item?.status === "active" && agentName ? ` · ${agentName}` : ""}
                </span>
              )}
              {item?.topic && item?.status !== "none" && (
                <span className="premium-chat-item-topic">{item.topic}</span>
              )}
            </div>
          )}
          <div className="premium-chat-item-bottom">
            <p>{item?.lastMessage || roleLabel}</p>
            {item.unreadCount > 0 && !isActive && (
              <span className="premium-chat-item-badge">{item.unreadCount}</span>
            )}
          </div>
        </div>

        {isMobileView && (
          <span className="premium-chat-item-chevron" aria-hidden="true">
            <i className="fas fa-chevron-right" />
          </span>
        )}
      </button>
    </li>
  );
}
